import request from '@/request/index';
import util from '@/libs/util';

//申报列表
export function DeclareList(urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/sysprojectcfgs/list' + parmas,
        method: 'get'
    });
}

//申报列表报名状态
export function DeclareListState(urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/auditmain/auditmain_stu' + parmas,
        method: 'get'
    });
}

//查询考生信息
export function UserNew(id) {
    return request({
        url: '/webapi/api/user_info/' + id,
        method: 'get'
    });
}

//医师列表
export function TeacherList(params) {
    return request({
        url: '/webapi/api/user_teacher/list/' + params.user_id + '?identity_type=' + params.identity_type,
        method: 'get'
    });
}

//获取医师某一条数据
export function Teacherdetails(id) {
    return request({
        url: '/webapi/api/user_teacher/' + id,
        method: 'get'
    });
}

//新建医师保存
export function AddTeacher(data) {
    return request({
        url: '/webapi/api/user_teacher',
        method: 'post',
        data
    });
}

//修改医师保存
export function updataTeacher(data) {
    return request({
        url: '/webapi/api/user_teacher',
        method: 'put',
        data
    });
}

//删除医师
export function DeleteTeacher(id) {
    return request({
        url: '/webapi/api/user_teacher/' + id,
        method: 'delete'
    });
}

//项目提交
export function Submitrequest(data) {
    return request({
        url: '/webapi/api/auditmain',
        method: 'post',
        data
    });
}

//步骤二下一步校验
export function nextStep(urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/auditmain/check_teacher_upfile/' + parmas,
        method: 'get'
    });
}

//获取老师信息列表
export function TeacherNew(id) {
    return request({
        url: '/webapi/api/user_teacher/list/' + id,
        method: 'get'
    });
}

//获取老师信息列表附件
export function TeacherNewFile(urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/uploadfile/list/' + parmas,
        method: 'get'
    });
}

//项目撤回
export function Withdraw(id) {
    return request({
        url: '/webapi/api/auditmain/auditmain_revoke/' + id,
        method: 'post'
    });
}

// 获取项目是否打印准考证
export function sysprojectcfgs(code) {
    return request({
        url: '/webapi/api/sysprojectcfgs/detail/' + code,
        method: 'get'
    });
}
